import ImmutablePropTypes from 'react-immutable-proptypes'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import React from 'react'
import {
  GIFT_MOBILE_BREAKPOINT,
  GIFT_READY_STATE,
} from '../../../services/gift/index'
import { getPlanDetails } from '../../../services/gift/utils/index'
import { USD } from '../../../services/currency/index'
import { PlanGridCurrency } from '../../PlanGridCurrency/index'
import { selectStaticTextByKey } from '../../../services/static-text/selectors'
import { TYPE_SELECT_GIFT_PLAN } from '../../../services/dialog/index'
import Sherpa, { TYPE_LARGE } from '../../Sherpa/index'
import { H3, HEADING_TYPES } from '../../Heading/index'
import { renderModal } from '../../../services/dialog/actions'
import { selectIsBreakpoint } from '../../../services/app/selectors'
import { selectPrimaryLanguage } from '../../../services/user/selectors'
import { selectRecipientEmail } from '../../../services/gift/selectors'
import Button, { TYPES } from '../../Button/index'

const GiftSelectionPropTypes = {
  planData: ImmutablePropTypes.list,
  selectedPlan: ImmutablePropTypes.map,
  mobileBreakpoint: PropTypes.number,
  showMobileTitle: PropTypes.bool,
  changeable: PropTypes.bool,
}

const staticTextStoreKey = 'giftSelection'

function getTitleText (changeable, staticText, recipientEmail) {
  if (changeable || !recipientEmail) {
    return staticText.get('yourSelection')
  }

  return (
    <React.Fragment>
      <span className="gift-selection__title-text-mobile">
        {staticText.get('successfullySent')}
      </span>
      <span className="gift-selection__title-text-desktop">
        {staticText.get('giftSuccessful')}
      </span>
    </React.Fragment>
  )
}

/**
 * @type {React.FC<PropTypes.InferProps<GiftSelectionPropTypes>>}
 * @returns {React.ReactElement}
 * */
export const GiftSelection = (props) => {
  const {
    mobileBreakpoint = GIFT_MOBILE_BREAKPOINT,
    canPurchaseGift,
    selectedPlan,
    changeable,
  } = props
  const staticText = useSelector(selectStaticTextByKey(staticTextStoreKey))
  const mobileView = useSelector(selectIsBreakpoint(mobileBreakpoint))
  const userLanguage = useSelector(selectPrimaryLanguage)
  const currencyIso = selectedPlan.get('currencyIso', USD) || USD
  const recipientEmail = useSelector(selectRecipientEmail)
  const dispatch = useDispatch()

  const {
    loaded,
    details: { valuePropositions, planName, price },
  } = getPlanDetails(selectedPlan, userLanguage)

  const onChangePlan = () => {
    dispatch(renderModal(TYPE_SELECT_GIFT_PLAN, { ...props }))
  }

  return (
    <div className="gift-selection__stars-wrapper">
      <div className="gift-selection__stars-desktop"></div>
      <H3
        as={[HEADING_TYPES.H6_MOBILE, HEADING_TYPES.H5_DESKTOP]}
        className="gift-selection__title"
      >{getTitleText(changeable, staticText, recipientEmail)}
      </H3>
      {currencyIso && (
        <PlanGridCurrency
          currencyIso={currencyIso}
          className="gift-selection__currency-taxes"
        />
      )}
      <div className="gift-selection__card">
        <p className="gift-selection__card-subtitle">
          {staticText.get('giftSelection')}
        </p>
        {loaded ? (
          <>
            <table>
              <tbody>
                <tr>
                  <td>{planName}</td>
                  <td>{price}</td>
                </tr>
              </tbody>
            </table>
            {currencyIso && (
              <PlanGridCurrency
                currencyIso={currencyIso}
                className="gift-selection__currency-taxes-mobile"
              />
            )}
            <ul className="gift-selection__value-props">
              {valuePropositions.map((vp, index) => (
                <li
                  className="gift-selection__value-list-item"
                  key={`plan-grid-value-prop-${index}`}
                >{vp}
                </li>
              ))}
            </ul>
          </>
        ) : (
          <Sherpa type={TYPE_LARGE} />
        )}
        {loaded
        && changeable
        && canPurchaseGift === GIFT_READY_STATE.CAN_PURCHASE ? (
          <Button
            type={mobileView ? TYPES.GHOST : TYPES.SECONDARY}
            disabled={!loaded}
            className="gift-selection__change-btn"
            onClick={onChangePlan}
          >{staticText.get('change')}
          </Button>
          ) : null}
      </div>
    </div>
  )
}

GiftSelection.propTypes = GiftSelectionPropTypes

export default GiftSelection
